const SALES_DEVICE_STORAGE_KEY = "anthem.sales.deviceInstallationId.v1";

function createDeviceInstallationId(): string {
  if (typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
}

export function getOrCreateSalesDeviceInstallationId(): string | undefined {
  if (typeof window === "undefined") return undefined;

  try {
    const existing = window.localStorage.getItem(SALES_DEVICE_STORAGE_KEY)?.trim();
    if (existing && /^[A-Za-z0-9_-]{16,128}$/.test(existing)) {
      return existing;
    }

    const created = createDeviceInstallationId();
    window.localStorage.setItem(SALES_DEVICE_STORAGE_KEY, created);
    return created;
  } catch {
    return undefined;
  }
}
